/*
 * @Author: 刑天
 * @Date: 2022-04-15 10:19:36
 * @LastEditTime: 2024-01-10 13:59:49
 * @Description: 战神
 */
import request from '@/utils/request';

//场景营销列表
export function getAppointActivityList(values) {
  return request('/activityBooking/queryActivityList', {
    method: 'POST',
    data: values,
  });
}

//场景营销列表停止活动
export function terminateActivityBooking(values) {
  return request('/activityBooking/terminate', {
    method: 'POST',
    data: values,
  });
}

//场景营销列表审核活动
export function approveActivityBooking(values) {
  return request('/activityBooking/approve', {
    method: 'POST',
    data: values,
  });
}

//场景营销列表删除活动
export function deleteActivityBooking(values) {
  return request('/activityBooking/deleteBooking', {
    method: 'POST',
    data: values,
  });
}
